import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class PagerDuty extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <rect x="4.729" y="17.608" width="3.516" height="6.392" />
        <path d="M17.969,1.172C16.082.167,14.773,0,11.684,0H4.729V14.549h6.924c2.755,0,4.809-.167,6.62-1.37a6.92,6.92,0,0,0,3-6A6.585,6.585,0,0,0,17.969,1.172ZM12.46,11.505H8.244V3.12l3.972-.031c3.622-.045,5.433,1.233,5.433,4.125C17.649,10.318,15.412,11.505,12.46,11.505Z" />
      </svg>
    );
  }
}

export default PagerDuty;
